module.exports = __webpack_public_path__ + "87b7908993bfaaf10595f844bfbd31fe.MP3";